import { ApolloLink } from "@apollo/client";
export default function createOperationTypeSplitLink(mutationsLink, queryLink) {
    return ApolloLink.split((operation)=>{
        var _operation_getContext_graphQlOperation;
        return ((_operation_getContext_graphQlOperation = operation.getContext().graphQlOperation) === null || _operation_getContext_graphQlOperation === void 0 ? void 0 : _operation_getContext_graphQlOperation.type) === 'MUTATION';
    }, mutationsLink, queryLink);
}

//# sourceMappingURL=createOperationTypeSplitLink.js.map